import { useEffect } from 'react';
import styled from 'styled-components';

import useModalState from '@/hooks/pure/useModalState';
import usePopupStore from '@/stores/pure/PopupStore';
import zIndex from '@/styles/zIndex';

import { Flex } from '../base';
import Modal from '../Modal/Modal';
import DefaultPopup from './DefaultPopup';

const PopupManager = () => {
  const popup = usePopupStore((state) => state.popup);
  const modalState = useModalState();

  useEffect(() => {
    if (popup) {
      modalState.open();
    } else {
      modalState.close();
    }
  }, [popup]);

  return (
    <Modal
      layerId="syncly-popup-layer"
      status={modalState.status}
      closeModal={modalState.close}
    >
      {popup && (
        <Style>
          <DefaultPopup {...popup} />
        </Style>
      )}
    </Modal>
  );
};

const Style = styled(Flex)`
  position: fixed;
  z-index: ${zIndex.popup};
`;

export default PopupManager;
